import { createSlice } from "@reduxjs/toolkit"
import { pasteCopy } from "./workspaceNoteSlice"

const initialState = {
	id: -1,
	includeAttachments: false,
	noteToPaste: null,
	workspaceId: -1
}

export const copyNoteSlice = createSlice({
	name: "copyNote",
	initialState,
	reducers: {
		initializeCopyNote: (state, action) => action.payload,
		cancelCopyNote: () => initialState,
		completeCopyNote: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(pasteCopy.fulfilled, () => initialState)
			.addCase(pasteCopy.rejected, () => initialState)
	}
})

export const { initializeCopyNote, cancelCopyNote, completeCopyNote } = copyNoteSlice.actions
export const selectCopyNote = (state) => state.copyNote
export const selectCopyNoteId = (state) => state.copyNote.id
export default copyNoteSlice.reducer